import Vue from 'vue';

export default {
    loadAllContributors(state) {
        Vue.set(state.contributors, 'data', []);
        Vue.set(state.contributors, 'dataLoading', true);
        Vue.set(state.contributors, 'hasLoaded', false);
    },
    loadAllContributorsSuccess(state, payload) {
        Vue.set(state.contributors, 'data', payload);
        Vue.set(state.contributors, 'dataLoading', false);
        Vue.set(state.contributors, 'hasLoaded', true);
    },
    loadAllContributorsError(state) {
        Vue.set(state.contributors, 'dataLoading', false);
        Vue.set(state.contributors, 'hasError', true);
        Vue.set(state.contributors, 'hasLoaded', true);
    },
    selectContributorForDetail(state, payload) {
        Vue.set(state.contributors, 'selectedContributorForDetail', payload);
    },
    selectContributorForAnswers(state, payload) {
        Vue.set(state.contributors, 'selectedContributorForAnswers', payload);
    },

};
